import React from 'react'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { connect } from 'react-redux'
import { FormButtons, validations, renderers } from '../../../components'

let ComponentIssueForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  componentIssuesOptions,
  reproducibilityOptions,
  selectedComponentCode,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs={12}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="component_code"
            label="Component Code"
          >
            {componentIssuesOptions &&
              componentIssuesOptions.map((state) => {
                return (
                  <option key={state.componentCode} value={state.componentCode}>
                    {state.componentDescription}
                  </option>
                )
              })}
          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12}>
          <Field
            name="issue_code"
            label="Issue Code"
            validate={[validations.required]}
            component={renderers.renderSelectField}
            as="select"
          >
            {selectedComponentCode &&
              componentIssuesOptions &&
              componentIssuesOptions.map &&
              componentIssuesOptions
                .filter((x) => x.componentCode === selectedComponentCode)[0]
                .issues.map((c) => {
                  return (
                    <option key={c.code} value={c.code}>
                      {c.description}
                    </option>
                  )
                })}
          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12}>
          <Field
            name="reproducibility"
            label="Reproducibility"
            validate={[validations.required]}
            component={renderers.renderSelectField}
            as="select"
          >
            {selectedComponentCode &&
              reproducibilityOptions &&
              reproducibilityOptions.map((c) => {
                return (
                  <option key={c.code} value={c.code}>
                    {c.description}
                  </option>
                )
              })}
          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="type"
            label="Issue Reported Type"
          >
            {[
              { code: 'CUST', label: 'Customer-Reported' },
              { code: 'TECH', label: 'Technician-Verified' },
            ].map((state) => {
              return (
                <option key={state.code} value={state.code}>
                  {state.label}
                </option>
              )
            })}
          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="priority"
            label="Issue Priority (Priority of components and issues, 1 - represents the Primary)"
          >
            {[1, 2, 3,4,5].map((state) => {
              return (
                <option key={`${state}-priority`} value={state}>
                  {state}
                </option>
              )
            })}
          </Field>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs={12}>
          <Field
            component={renderers.renderSelectField}
            as="select"
            validate={[validations.required]}
            name="order"
            label="Issue order(Display order of components and issues)"
          >
            {[1, 2, 3,4,5].map((state) => {
              return (
                <option key={`${state}-order`} value={state}>
                  {state}
                </option>
              )
            })}
          </Field>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
ComponentIssueForm = reduxForm({
  form: 'ComponentIssueForm',
})(ComponentIssueForm)
const selector = formValueSelector('ComponentIssueForm')
ComponentIssueForm = connect((state) => {
  const selectedComponentCode = selector(state, 'component_code')
  return {
    selectedComponentCode,
  }
})(ComponentIssueForm)
export default ComponentIssueForm
